module.exports = __webpack_public_path__ + "static/media/aep6nkPOCy0.e871e0f9.png";